import HttpClient from 'server/helpers/HttpClient';
import SegmentIO from 'reporting/SegmentIO';

const httpClient = HttpClient.getInstance();
const { SplunkReporter } = require('reporting/splunk/SplunkReporter');
const splunkReporter = SplunkReporter.getInstance();
const logger = 'businessLogic/Auth';
export default class Auth {
  constructor({ initialState, config }) {
    this.config = config;
    this._data = initialState.auth;
  }

  updateData(data) {
    this._data = { ...this._data, ...data };
  }

  signIn(entityId, endpoints) {
    localStorage.setItem('from_sign_in', 'true');
    SegmentIO.transactionEngaged({
      activity_type: 'sign_in',
      ui_object: 'link',
      ui_action: 'clicked',
      ui_access_point: 'transaction_flow',
      ui_object_detail: 'wallet_sign_in',
    });

    splunkReporter.contextual({
      logInfo: { logLevel: 'info', logger },
      event: 'signIn',
      action: 'redirect',
    });
    window.location.href = endpoints.signInURL;
  }

  signUp(entityId, endpoints) {
    splunkReporter.contextual({
      logInfo: { logLevel: 'info', logger },
      event: 'signUp',
      action: 'redirect',
    });
    localStorage.setItem('from_sign_up', 'true');
    SegmentIO.transactionEngaged({
      activity_type: 'sign_up',
      ui_object: 'link',
      ui_action: 'clicked',
      ui_access_point: 'transaction_flow',
      ui_object_detail: 'wallet_sign_up',
    });

    window.location.href = endpoints.signUpURL;
  }

  async signOut(token) {
    const { ssrtid, portal } = this.config;
    const endpoint = `/${portal}/rest/authenticate/logout`;
    splunkReporter.contextual({
      logInfo: { logLevel: 'info', logger },
      event: 'signOut',
      action: 'clicked',
    });

    await httpClient({
      url: endpoint,
      method: 'DELETE',
      ssrtid,
      token,
      ignoreProfilingInterceptor: true,
      event: 'signOut',
    });

    setTimeout(() => {
      window.location.reload();
    }, 0);
  }

  get authLevel() {
    return this._data.authLevel;
  }

  get realmId() {
    return this._data.realmId;
  }

  get entityId() {
    return this._data.entityId;
  }

  get isUserSignedIn() {
    return this._data.isUserSignedIn;
  }

  get isEntityPromoted() {
    return this._data.isEntityPromoted;
  }

  get ticket() {
    return this._data.ticket;
  }

  get authToken() {
    return this._data.authToken;
  }

  get regionIsoCode() {
    return this._data.regionIsoCode;
  }

  get recipientEmail() {
    return this._data.recipientEmail;
  }

  get syncToken() {
    return this._data.syncToken;
  }

  /**
   * Generate factor token for frictionless login
   * @param {Object} params - Parameters for generating factor
   * @param {string} params.email - User's email address
   * @param {string} params.token - Sales checkout token
   * @returns {Promise<{factorToken: string}>} Factor token response
   */
  async generateFactor({ email, token }) {
    const { portal } = this.config;
    const { authToken } = this._data;

    const requestHeaders = {
      Accept: 'application/json, text/javascript, */*; q=0.01',
      'Intuit-ACSToken': token,
      sessionTicket: authToken,
      Authorization: `Bearer ${authToken}`,
      'intuit-realmid': this._data.realmId,
    };

    const url = `/${portal}/rest/authenticate/generate-factor`;
    const endpoint = '/rest/authenticate/generate-factor';

    try {
      const response = await httpClient({
        url,
        method: 'POST',
        data: { email, authToken },
        headers: requestHeaders,
        endpoint,
        event: 'generateFactor',
      });

      splunkReporter.contextual({
        logInfo: { logLevel: 'info', logger },
        event: 'generateFactor',
        action: 'success',
        email,
      });

      return response.data;
    } catch (error) {
      splunkReporter.contextual({
        logInfo: { logLevel: 'error', logger },
        event: 'generateFactor',
        action: 'error',
        error: {
          message: error.message,
          status: error.response?.status,
        },
      });
      throw error;
    }
  }
}
